export default "<p>socket works!</p>\r\n";